/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetTimecardRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {TimecardResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const getTimecard = (request: GetTimecardRequest, options?: CashRequestOptions) => post<GetTimecardRequest, TimecardResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/GetTimecard", request, {...options, rejectOnError: true })